import React from 'react';

import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import { getAdminURL } from 'src/presentation/components/pages/shared/utils/Utils';

const EmailSetupDescription = () => {
  return <EntryPoints />;
};

const EntryPoints = () => (
  <div>
    Configure your sending domain and associated email addresses.{' '}
    <ExternalLink
      data-aid="set-up-email-help-link"
      label="Read Set Up Email"
      to="https://help.gladly.com/implementation/docs/set-up-email"
    />{' '}
    to learn more. Looking to manage your inboxes?{' '}
    <ExternalLink data-aid="channels-help-link" label="Go to Entry Points" to={getAdminURL('entry-points')} />
  </div>
);

export default EmailSetupDescription;
